module.exports = __webpack_public_path__ + "img/placenta.7f405292.png";